export const homeFr = {
  home: 'Accueil',
  about: 'À Propos',
  projects: 'Nos Services',
  statistics: 'Statistiques',
  services: 'Services',
  contact: 'Contactez-nous',
  heroTitle: 'Association Al-Falah pour les Œuvres Sociales et Culturelles',
  associationName: 'Association Al-Falah',
  heroSubtitle: 'Système de Gestion des Cercles - Plateforme complète pour la gestion des cercles de mémorisation du Coran',
  adminLogin: 'Connexion Administrateur',
  teacherLogin: 'Connexion Enseignant',
  parentLogin: 'Connexion Parent',
  aboutTitle: 'À Propos',
  aboutText: 'L\'Association Al-Falah pour les Œuvres Sociales et Culturelles est une organisation caritative qui vise à promouvoir les valeurs islamiques et culturelles dans la société. Nous nous concentrons sur la gestion des cercles de mémorisation du Coran et la fourniture de services éducatifs et culturels à la communauté.',
  readMore: 'Lire la suite',
  projectsTitle: 'Nos Services Principaux',
  project1Title: 'Gestion des Étudiants',
  project1Desc: 'Système complet pour gérer les données des étudiants et suivre leurs progrès dans la mémorisation du Coran avec la possibilité d\'ajouter et de modifier les données.',
  project2Title: 'Gestion des Notes',
  project2Desc: 'Système d\'évaluation complet pour enregistrer les notes des étudiants et suivre leurs performances dans les cercles avec la possibilité d\'envoyer des rapports aux parents.',
  project3Title: 'Communication avec les Parents',
  project3Desc: 'Plateforme de communication efficace entre les enseignants et les parents pour envoyer des messages, des rapports et suivre les progrès des étudiants.',
  project4Title: 'Gestion des Enseignants',
  project4Desc: 'Système de gestion complet des enseignants avec la possibilité de suivre leurs performances, les évaluer et gérer leurs emplois du temps.',
  statsTitle: 'Statistiques de l\'Association',
  statStudents: 'Étudiants',
  statTeachers: 'Enseignants',
  statCircles: 'Cercles',
  statParents: 'Parents',
  servicesTitle: 'Nos Services',
  service1Title: 'Cercles de Mémorisation du Coran',
  service1Desc: 'Cercles spécialisés pour la mémorisation du Coran en utilisant des méthodes modernes et avancées',
  service2Title: 'Éducation Religieuse',
  service2Desc: 'Programmes éducatifs complets pour les sciences islamiques et juridiques',
  service3Title: 'Activités Culturelles',
  service3Desc: 'Événements et programmes culturels divers pour promouvoir les valeurs islamiques',
  service4Title: 'Services Sociaux',
  service4Desc: 'Programmes et initiatives sociales pour servir la communauté',
  footerText: 'Tous droits réservés - Fondation Athar Al-Quran',
  footerPoweredBy: 'Logiciel utilisé par : Association Al-Falah pour les Œuvres Sociales et Culturelles',
  privacyPolicy: 'Politique de Confidentialité',
  contactUs: 'Contactez-nous',
  address: 'Adresse: Royaume du Maroc',
  phone: 'Téléphone: +212 XX XXX XXXX',
  email: 'Email: info@alfalah.org',

  // Formulaire contact public
  contactFormTitle: 'Envoyez-nous un message',
  contactName: 'Nom complet',
  contactPhone: 'Téléphone',
  contactEmail: 'Email',
  contactSubject: 'Objet',
  contactMessage: 'Message',
  contactSend: 'Envoyer le message',
  contactSending: 'Envoi en cours...',
  contactPhoneOrEmailHint: 'Téléphone ou email requis',
  contactSuccess: 'Message envoyé avec succès !',
  contactSuccessMsg: 'Merci de nous avoir contactés. Nous vous répondrons bientôt.',
  contactRefLabel: 'Numéro de votre demande',
  contactErrName: 'Veuillez saisir votre nom complet',
  contactErrSubject: 'Veuillez saisir l\'objet',
  contactErrMsg: 'Veuillez saisir votre message (10 caractères minimum)',
  contactErrPhoneOrEmail: 'Veuillez saisir un téléphone ou un email',
  contactErrGeneric: 'Une erreur est survenue. Veuillez réessayer.',
  contactErrLimit: 'Trop de requêtes. Veuillez réessayer plus tard.',
  contactSendNew: 'Envoyer un autre message',

  // Demande d'inscription
  inscriptionBtn: 'Demande d\'inscription',
  inscriptionTitle: 'Demande d\'inscription',
  inscriptionSubtitle: 'Remplissez les informations ci-dessous pour soumettre votre demande d\'inscription',
  inscriptionTypeLabel: 'Type de demande',
  inscriptionTypeParent: 'Parent',
  inscriptionTypeTeacher: 'Enseignant',
  inscriptionParentModeNew: 'Nouveau parent',
  inscriptionParentModeExisting: 'Parent déjà inscrit',
  inscriptionName: 'Nom complet',
  inscriptionPhone: 'Téléphone',
  inscriptionEmail: 'Email (optionnel)',
  inscriptionGender: 'Genre',
  inscriptionGenderMale: 'Masculin',
  inscriptionGenderFemale: 'Féminin',
  inscriptionAddress: 'Adresse (optionnel)',
  inscriptionNotes: 'Notes (optionnel)',
  inscriptionExistingUsername: 'Nom d\'utilisateur',
  inscriptionExistingPassword: 'Mot de passe',
  inscriptionChildrenTitle: 'Informations des enfants',
  inscriptionChildName: 'Nom de l\'élève',
  inscriptionChildLevel: 'Niveau',
  inscriptionChildHalqa: 'Cercle',
  inscriptionChildNotes: 'Notes',
  inscriptionAddChild: '+ Ajouter un enfant',
  inscriptionRemoveChild: 'Supprimer',
  inscriptionVerify: 'Vérifier',
  inscriptionVerifying: 'Vérification...',
  inscriptionChange: 'Modifier',
  inscriptionExistingChildren: 'Enfants déjà inscrits',
  inscriptionNewChildren: 'Nouveaux enfants à inscrire',
  inscriptionRenewSection: 'Réinscription des enfants',
  inscriptionAlreadyRenrolled: 'Déjà réinscrit',
  inscriptionSelected: 'Sélectionné',
  inscriptionSelectRenroll: 'Réinscrire',
  inscriptionErrAtLeastOne: 'Sélectionnez au moins une réinscription ou ajoutez un nouvel enfant',
  inscriptionNoChildrenFound: 'Aucun enfant trouvé pour ce compte',
  inscriptionTeacherTitle: 'Informations de l\'enseignant',
  inscriptionHalqa: 'Cercle assigné',
  inscriptionExperience: 'Années d\'expérience (optionnel)',
  inscriptionSpecialization: 'Spécialisation (optionnel)',
  inscriptionCertDate: 'Date de certification (optionnel)',
  inscriptionSubmit: 'Envoyer la demande',
  inscriptionSubmitting: 'Envoi en cours...',
  inscriptionSuccess: 'Demande envoyée avec succès !',
  inscriptionSuccessMsg: 'Votre demande sera examinée et nous vous contacterons prochainement.',
  inscriptionRequestNumber: 'Numéro de votre demande',
  inscriptionBack: 'Retour',
  inscriptionErrName: 'Veuillez saisir le nom complet',
  inscriptionErrPhone: 'Veuillez saisir le numéro de téléphone',
  inscriptionPhoneMissingHint: 'Aucun numéro enregistré sur votre compte : merci de le saisir pour finaliser la demande.',
  inscriptionErrHalqa: 'Veuillez sélectionner un cercle',
  inscriptionErrChildName: 'Veuillez saisir le nom de l\'élève',
  inscriptionErrGeneric: 'Une erreur est survenue. Veuillez réessayer.',
  inscriptionErrLimit: 'Trop de requêtes. Veuillez réessayer plus tard.',
  inscriptionErrCredentials: 'Identifiants incorrects.',
  inscriptionErrParentMode: 'Veuillez choisir le type de demande parent',
  inscriptionErrCredentialsRequired: 'Veuillez saisir le nom d\'utilisateur et le mot de passe',
  inscriptionLvlNursery: 'Maternelle',
  inscriptionLvl1: '1ère année',
  inscriptionLvl2: '2ème année',
  inscriptionLvl3: '3ème année',
  inscriptionLvl4: '4ème année',
  inscriptionLvl5: '5ème année',
  inscriptionLvlPrep: 'Collège',
  inscriptionHalqaListen: 'Cercle d\'écoute',
  inscriptionHalqaMushaf: 'Cercle du Mushaf',
  inscriptionHalqaReview: 'Cercle de révision',
  inscriptionChild: 'Enfant',
  inscriptionOptional: 'optionnel',

  // Fondation Athar
  foundationName: 'Fondation Athar Al-Quran',
  foundationAbout: 'Fondation dédiée à la diffusion des enseignements du Coran et à faciliter sa mémorisation',
  foundationContact: 'Contacter la fondation',
  foundationEmail: 'atharalquran.org@gmail.com',
  foundationPhone: '+212767532742',
  foundationInfoTitle: 'À propos de la Fondation Athar Al-Quran',
  foundationModalSubtitle: 'Application gratuite de gestion des cercles de mémorisation du Coran',
  foundationModalBody: 'Application gratuite développée par la Fondation Athar pour le Saint Coran, destinée à toutes les associations et instituts de mémorisation du Coran.\n\nTrois espaces indépendants : Administrateur, Enseignant et Parent.\n\nPermet de gérer les élèves et les enseignants, suivre les séances de mémorisation et la progression coranique, enregistrer les notes et examens, gérer les finances et assurer la communication interne entre tous les acteurs.\n\nDisponible en trois langues : Arabe, Français et Anglais.\n\nDisponible sur Web, Android et iOS.',
  foundationEmailBtn: 'Email',
  foundationCallBtn: 'Appeler',
  foundationClose: 'Fermer',
  foundationComposeTitle: 'Écrire à la fondation',
  foundationComposeTo: 'À :',
  foundationYourName: 'Votre nom',
  foundationNamePlaceholder: 'Nom et prénom',
  foundationYourEmail: 'Votre e-mail',
  foundationEmailPlaceholder: 'email@exemple.com',
  foundationYourPhone: 'Téléphone',
  foundationPhonePlaceholder: '+212767532742',
  foundationSubject: 'Sujet',
  foundationSubjectPlaceholder: 'Objet du message',
  foundationMessage: 'Message',
  foundationMessagePlaceholder: 'Votre message...',
  foundationSend: 'Envoyer',
  foundationDefaultSubject: 'Message depuis la plateforme El Falah',
  foundationErrRequired: 'Veuillez renseigner votre nom et votre message.',
  foundationWriteEmail: 'Écrire à la fondation',
};

